<p class="marquee">
  <span>        💡 Paying from Pakistan? You can now pay in PKR via JazzCash & EasyPaisa — no need for a dollar account!
 &nbsp;</span>
</p>
<p class="marquee marquee2">
  <span>        💡 Paying from Pakistan? You can now pay in PKR via JazzCash & EasyPaisa — no need for a dollar account!
 &nbsp;</span>
</p>
@if (scrollTop == 0 || scrollUp || IsComeJoinUs) {
<nav class="navbar py-3" id="navbar_top" [ngClass]="{
      shadow: (scrollUp && scrollTop > 0) || (scrollTop > 0 && IsComeJoinUs)
    }">
  <div class="container navbar_container justify-content-between">
    <div class="leftSide d-flex align-items-center">
       @if ((resize.windowSize$ | async)?.width < 1024) {
      <div class="d-lg-none me-3">
  <button (click)="isMobileMenuOpen = !isMobileMenuOpen" class="btn p-0 border-0 bg-transparent mobile-menu-toggle" >
    <fa-icon [icon]="fabar" style="font-size: 22px;"></fa-icon>
  </button>
</div>}
      <a class="navbar-brand dCenter" routerLink="/">
        @if ((resize.windowSize$ | async)?.width > 1024) {
        <img class="lazyImage" [useSrcset]="true" aspect-ratio="1" alt="image" width="100%" height="100%"
          defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
          [lazyLoad]="scrollTop == 0 ? logo : scrollLogo" />
        } @else {
        <img class="lazyImage" [useSrcset]="true" aspect-ratio="1" alt="image" width="100%" height="100%"
          defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
          [lazyLoad]="scrollTop == 0 ? smallLogo : smallScrollLogo" />
        }
      </a>
      @if ((resize.windowSize$ | async)?.width > 1024) {
      <a class="linkItem gilroy-m" style="margin-right: 20px" routerLink="/mega-sessions"> Upcoming Sessions </a>
      <span class="gilroy" style="margin-right: 20px; color: #D0D0D0; opacity: .8;">
        |
      </span>
      <a class="linkItem gilroy-m" routerLink="/mega-sessions/recordings"> Recorded Sessions </a>
      }
    </div>
    <div class="d-flex">
      @if (!userDetails) {
      @if ((resize.windowSize$ | async)?.width <= 520) { <div class="searchBtn searchBtnMobile">
        <button (click)="toggleSearchMobile()" class="searchBox oHideBox dCenter bg-transparent border-0"
          aria-label="Search Button">
          <fa-icon [icon]="faSearch" style="font-size: 18px; color: #002544">
          </fa-icon>
        </button>
    </div>
    }

    @if ((resize.windowSize$ | async)?.width > 520) {
    <div class="search mb5 wow fadeInDown d-flex" [ngClass]="{
                'search-bg': true
              }">
      <input type="text" name="q" class="gilroy-sb form-control search-input-round" [ngClass]="{
                  'search-input': (resize.windowSize$ | async)?.width > 520
                }" placeholder="Search Creators..." autocomplete="off" [(ngModel)]="mentorSearchQuery"
        (ngModelChange)="this.mentorSearchQueryUpdate.next($event)" [class.active]="true" />
      <button (click)="toggleSearch()" class="searchBox oHideBox dCenter bg-transparent border-0"
        aria-label="Search Button">
        <fa-icon [icon]="searchValue ? faTimes : faSearch" style="font-size: 18px; color: #002544"
          [class.text-danger]="searchValue"></fa-icon>
      </button>
      <div #suggestions>
        @if (showSearch) {
        <app-search-suggestions [extra]="true" [searchState]="searchValue" (showEmit)="reset()"
          [show]="showSearch"></app-search-suggestions>
        }
      </div>
    </div>
    }

    @if ((resize.windowSize$ | async)?.width > 520) {
    <div class="d-flex align-items-center justify-content-center gap-4" style="margin-right: 24px">
      <a class="linkItem gilroy-m" routerLink="/creators"> Creators </a>

      <button class="linkItem gilroy-m" (click)="navigateToLoginScreen()"
        style="cursor: pointer; background: none; border: none;">
        Login
      </button>
    </div>
    }

    <button class="dark-button gilroy" routerLink="/signup" type="button">
      Join Now
    </button>
    }
  </div>
  @if (userDetails) {
  <div class="d-flex align-items-center justify-content-center">
    @if ((resize.windowSize$ | async)?.width <= 520) { <div class="searchBtn searchBtnMobile">
      <button (click)="toggleSearchMobile()" class="searchBox oHideBox dCenter bg-transparent border-0"
        aria-label="Search Button">
        <fa-icon [icon]="faSearch" style="font-size: 18px; color: #002544">
        </fa-icon>
      </button>
  </div>
  }

  @if ((resize.windowSize$ | async)?.width > 520) {
  <div class="search mb5 wow fadeInDown d-flex" [ngClass]="{
                'search-bg': true
              }">
    <input type="text" name="q" class="gilroy-sb form-control search-input-round" [ngClass]="{
                  'search-input': (resize.windowSize$ | async)?.width > 520
                }" placeholder="Search Creators..." autocomplete="off" [(ngModel)]="mentorSearchQuery"
      (ngModelChange)="this.mentorSearchQueryUpdate.next($event)" [class.active]="true" />
    <button (click)="toggleSearch()" class="searchBox oHideBox dCenter bg-transparent border-0"
      aria-label="Search Button">
      <fa-icon [icon]="searchValue ? faTimes : faSearch" style="font-size: 18px; color: #002544"
        [class.text-danger]="searchValue"></fa-icon>
    </button>
    <div #suggestions>
      @if (showSearch) {
      <app-search-suggestions [extra]="true" [searchState]="searchValue" (showEmit)="reset()"
        [show]="showSearch"></app-search-suggestions>
      }
    </div>
  </div>
  }

  @if ((resize.windowSize$ | async)?.width > 520) {
  <a class="linkItem gilroy" style="margin-right: 20px" routerLink="/creators"> Creators </a>

  @if(userDetails?.fullName){
  <span class="gilroy" style="margin-right: 20px; color: #D0D0D0; opacity: .8;">
    |
  </span>
  <span class="linkItem gilroy">{{ userDetails?.fullName }}</span>
  }

  }
  <div class="dropdown">
    <a class="text-white cursor text-decoration-none position-relative d-flex align-items-center"
      id="dropdownMenuButton1" data-bs-toggle="dropdown">
      <div class="profileBox oHideBox dCenter">
        <img class="lazyImage"
          defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
          [useSrcset]="true" [lazyLoad]="
                    userDetails?.profileImage ||
                    'https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp'
                  " alt="image" width="100%" height="100%" id="imgChanges" />
      </div>
      <div class="arrowDown dCenter">
        <fa-icon [icon]="faAngleDown" class="text-light"></fa-icon>
      </div>
    </a>

    <ul class="dropdown-menu py-0 gilroy border-0" aria-labelledby="dropdownMenuButton1">
      @if (userDetails?.fullName) {
      <li>
        <a class="dropdown-item rounded-top">
          Hi, {{ userDetails?.fullName }} ({{ userDetails?.userType }})
        </a>
      </li>
      }
      @if (userDetails?.userTypeId == userAccountTypes.Fan) {
      <li>
        <a class="dropdown-item text-white" routerLink="/fan/chats">
          <fa-icon [icon]="faComment" class="mx-1"></fa-icon>
          Chats
        </a>
      </li>
      <li>
        <a class="dropdown-item text-white" routerLink="/fan/emeetings">
          <fa-icon [icon]="faUsers" class="mx-1"></fa-icon>
          eMeetings
        </a>
      </li>
      <li>
        <a class="dropdown-item text-white" routerLink="/fan/wallet">
          <fa-icon [icon]="faWallet" class="mx-1"></fa-icon>
          Wallet
        </a>
      </li>
      <li>
        <a class="dropdown-item text-white" routerLink="/fan/profile-update">
          <fa-icon [icon]="faGear" class="mx-1"></fa-icon>
          Edit Profile
        </a>
      </li>
      }
      @if (userDetails?.userTypeId == userAccountTypes.Creator) {
      <li>
        <a class="dropdown-item text-white" routerLink="/creator/dashboard">
          <fa-icon [icon]="faHome" class="mx-1"></fa-icon>
          Dashboard
        </a>
      </li>
      <li>
        <a class="dropdown-item text-white" routerLink="/creator/chats">
          <fa-icon [icon]="faComment" class="mx-1"></fa-icon>
          Chats
        </a>
      </li>
      <li>
        <a class="dropdown-item text-white" routerLink="/creator/emeetings">
          <fa-icon [icon]="faUsers" class="mx-1"></fa-icon>
          eMeetings
        </a>
      </li>
      <li>
        <a class="dropdown-item text-white" routerLink="/creator/profile-update">
          <fa-icon [icon]="faGear" class="mx-1"></fa-icon>
          Edit Profile
        </a>
      </li>
      }
      <li>
        <a class="dropdown-item text-white rounded-bottom cursor" (click)="helper.showModal(true, 'logoutModal')">
          <fa-icon [icon]="faSignOut" class="mx-1"></fa-icon>
          Logout
        </a>
      </li>
    </ul>
  </div>
  </div>
  }
  </div>

  @if ((resize.windowSize$ | async)?.width <= 520) { @if (inputActiveMobile) { <div
    class="container justify-content-center">
    <div class="search-mobile mb5 d-flex search-bg">
      <input type="text" name="q" class="gilroy-sb form-control search-input active search-input-round"
        placeholder="Search Creators..." autocomplete="off" [(ngModel)]="mentorSearchQuery"
        (ngModelChange)="this.mentorSearchQueryUpdate.next($event)" />
      <button (click)="reset()" class="searchBox oHideBox dCenter bg-transparent border-0" aria-label="Search Button">
        <fa-icon [icon]="searchValue ? faTimes : faSearch" style="font-size: 18px; color: #002544"
          [class.text-danger]="searchValue"></fa-icon>
      </button>
      <div #suggestions>
        @if (showSearch) {
        <app-search-suggestions [extra]="true" [searchState]="searchValue" (showEmit)="reset()"
          [show]="showSearch"></app-search-suggestions>
        }
      </div>
    </div>
    </div>
    }
    }
</nav>
}
@if ((resize.windowSize$ | async)?.width < 1024){
<div *ngIf="isMobileMenuOpen" class="custom-mobile-menu shadow-sm">
  <a routerLink="/mega-sessions" (click)="isMobileMenuOpen = false">📅 Upcoming Sessions</a>
  <a routerLink="/mega-sessions/recordings" (click)="isMobileMenuOpen = false">🎥 Recorded Sessions</a>
   @if (!userDetails) {
  <button class="btn btn-outline-primary mt-2 w-100 dropdownloginbtn" (click)="navigateToLoginScreen()">Login</button>
   }
</div>}

@if ((resize.windowSize$ | async)?.width < 1024) { @if (isAppleBtn) { @if (show) { <div class="tobBtnContainer">
  <app-redirect-app icon="apple"></app-redirect-app>
  </div>
  }
  <button (click)="show = !show" [class.clicked]="show" class="dCenter topBtn apple oHideBox">
    <img class="lazyImage"
      defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
      lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1717070677/new/8e146e9e28baeb9b59c6004ed7b1343b_fwtmjp.webp"
      alt="image" width="100%" height="100%" id="imgChanges" />
  </button>
  }
  @if (isAndriodBtn) {
  @if (show) {
  <div class="tobBtnContainer">
    <app-redirect-app icon="android"></app-redirect-app>
  </div>
  }
  <button (click)="show = !show" [class.clicked]="show" class="dCenter topBtn oHideBox">
    <img class="lazyImage"
      defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
      lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1717070677/new/google-play-store-mobile-apps-logo-free-png_gshlfl.webp"
      alt="image" width="100%" height="100%" id="imgChanges" />
  </button>
  }
  }
  @if (showInstallButton) {
  <button title="Easily Install Mentoga on Your Device or System for an Enhanced Experience" (click)="onInstall()"
    class="dCenter topBtn oHideBox" [ngClass]="{ install: (resize.windowSize$ | async)?.width < 1024 }">
    <img class="lazyImage"
      defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
      lazyLoad="https://cdn.iconscout.com/icon/free/png-256/free-download-1767976-1502312.png" alt="image" width="100%"
      height="100%" id="imgChanges" />
  </button>
  }


  


  <app-add-creator-info></app-add-creator-info>